/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as WhyAurelineRouteImport } from './routes/why-aureline';
import { Route as AboutRouteImport } from './routes/about';
import { Route as IndexRouteImport } from './routes/index';
import { Route as ServicesIndexRouteImport } from './routes/services.index';
import { Route as ServicesServiceIdRouteImport } from './routes/services.$serviceId';

const WhyAurelineRoute = WhyAurelineRouteImport.update({
  id: '/why-aureline',
  path: '/why-aureline',
  getParentRoute: () => rootRouteImport,
} as any);
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const ServicesIndexRoute = ServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => rootRouteImport,
} as any);
const ServicesServiceIdRoute = ServicesServiceIdRouteImport.update({
  id: '/services/$serviceId',
  path: '/services/$serviceId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/why-aureline': typeof WhyAurelineRoute;
  '/services/$serviceId': typeof ServicesServiceIdRoute;
  '/services/': typeof ServicesIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/why-aureline': typeof WhyAurelineRoute;
  '/services/$serviceId': typeof ServicesServiceIdRoute;
  '/services': typeof ServicesIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/why-aureline': typeof WhyAurelineRoute;
  '/services/$serviceId': typeof ServicesServiceIdRoute;
  '/services/': typeof ServicesIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/about'
    | '/why-aureline'
    | '/services/$serviceId'
    | '/services/';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/about' | '/why-aureline' | '/services/$serviceId' | '/services';
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/why-aureline'
    | '/services/$serviceId'
    | '/services/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AboutRoute: typeof AboutRoute;
  WhyAurelineRoute: typeof WhyAurelineRoute;
  ServicesServiceIdRoute: typeof ServicesServiceIdRoute;
  ServicesIndexRoute: typeof ServicesIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/why-aureline': {
      id: '/why-aureline';
      path: '/why-aureline';
      fullPath: '/why-aureline';
      preLoaderRoute: typeof WhyAurelineRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/about': {
      id: '/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof AboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/services/': {
      id: '/services/';
      path: '/services';
      fullPath: '/services/';
      preLoaderRoute: typeof ServicesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/services/$serviceId': {
      id: '/services/$serviceId';
      path: '/services/$serviceId';
      fullPath: '/services/$serviceId';
      preLoaderRoute: typeof ServicesServiceIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  WhyAurelineRoute: WhyAurelineRoute,
  ServicesServiceIdRoute: ServicesServiceIdRoute,
  ServicesIndexRoute: ServicesIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
